import React, { useState } from "react";
import { CloseIcon, BinIcon } from "components/Icons";
import "styles/ImageUploadInput.css"; // reuse existing styles: iuu-*

/**
 * ImageGallery — reusable thumbnail strip with lightbox overlay.
 * Includes its own flex wrapper so spacing looks consistent when used standalone.
 *
 * Props:
 *  - images: Array<{ id: string, url: string }>
 *  - onDelete?: (id: string) => void   // If provided, shows a Bin icon & deletes image.
 */
export default function ImageGallery({ images, onDelete }) {
  const [selectedId, setSelectedId] = useState(null);
  const selectedImage = images.find((img) => img.id === selectedId);

  return (
    <>
      {/* Thumbnails / placeholder wrapped to retain spacing when standalone */}
      <div className="iuu-wrapper">
        {images.length === 0 ? (
          <span className="iuu-placeholder">No images selected</span>
        ) : (
          images.map(({ id, url }) => (
            <img
              key={id}
              src={url}
              alt="preview"
              onClick={() => setSelectedId(id)}
              className="iuu-thumb"
            />
          ))
        )}
      </div>

      {/* Lightbox overlay */}
      {selectedImage && (
        <div
          role="dialog"
          aria-modal="true"
          className="iuu-overlay"
          onClick={() => setSelectedId(null)}
        >
          <div
            className="iuu-overlay-controls"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              aria-label="Close viewer"
              className="iuu-overlay-btn"
              onClick={() => setSelectedId(null)}
            >
              <CloseIcon width={18} height={18} />
            </button>
            {onDelete && (
              <button
                aria-label="Delete image"
                className="iuu-overlay-btn"
                onClick={() => {
                  onDelete(selectedId);
                  setSelectedId(null);
                }}
              >
                <BinIcon width={18} height={18} />
              </button>
            )}
          </div>

          <img
            src={selectedImage.url}
            alt="selected preview"
            className="iuu-overlay-img"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </>
  );
}
